import type { InvoiceData } from "@/apis/gql/types";

export function hasFullConfidence(invoice: InvoiceData): boolean {
  const taxCodeGreen = invoice?.taxCodeConfidence;

  const amountGreen = invoice?.totalAmountConfidence;

  const serviceDateGreen = invoice?.serviceDateConfidence;

  const invoiceDateGreen = invoice?.invoiceDateConfidence;

  const accountGreen = invoice?.accountConfidence;

  const supplierGreen =
    invoice?.supplierMatchConfidence === 1 &&
    invoice?.supplier?.status === "CONFIRMED";

  const invoiceNoGreen = invoice?.invoiceNoConfidence === 1;

  const allFieldsGreen =
    taxCodeGreen &&
    amountGreen &&
    serviceDateGreen &&
    invoiceDateGreen &&
    accountGreen &&
    supplierGreen &&
    invoiceNoGreen;

  const noTags = invoice?.tags?.length === 0 && !invoice.isDuplicate;

  return Boolean(allFieldsGreen && noTags);
}
